import { motion } from "framer-motion";
import Reveal, { EASE } from "./Reveal";

const TERMS = [
  { term: "SUBSTANCE", desc: "Tangible fundamentals and asset-backed durability over market noise." },
  { term: "PERSPECTIVE", desc: "Generational horizons instead of short-term movements." },
  { term: "GROWTH", desc: "Active value creation through partnership and development." },
];

export default function Philosophy() {
  return (
    <section
      data-testid="philosophy"
      className="px-6 py-28 sm:px-[8vw] sm:py-40"
    >
      <p className="f-mono mb-4 text-[11px] tracking-[0.35em] text-[#B8860B]">
        INVESTMENT PHILOSOPHY
      </p>
      <Reveal>
        <h2 className="f-display max-w-3xl text-3xl font-light tracking-tight text-slate-900 sm:text-5xl">
          Capital, bundled with a <span className="italic text-[#B8860B]">long-term perspective.</span>
        </h2>
      </Reveal>
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-10% 0px" }}
        transition={{ duration: 1, delay: 0.2, ease: EASE }}
        className="mt-8 max-w-2xl text-base font-light leading-relaxed text-slate-600 sm:text-lg"
      >
        We invest selectively. We think entrepreneurially. We seek substance over
        short-term trends. And we view investments not in isolation, but as part
        of a long-term wealth strategy.
      </motion.p>

      <div className="mt-20">
        {TERMS.map((t, i) => (
          <motion.div
            key={t.term}
            data-testid={`philosophy-${t.term.toLowerCase()}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-12% 0px" }}
            transition={{ duration: 0.9, delay: i * 0.08, ease: EASE }}
            className="group grid items-baseline gap-3 border-t border-slate-200 py-8 transition-colors duration-500 hover:border-[#D4AF37]/50 sm:grid-cols-12 sm:py-10"
          >
            <span className="f-mono text-xs tracking-[0.3em] text-[#B8860B] sm:col-span-2">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="f-display text-3xl font-light tracking-wide text-slate-900 transition-transform duration-500 group-hover:translate-x-2 sm:col-span-5 sm:text-5xl">
              {t.term}
            </h3>
            <p className="text-sm font-light leading-relaxed text-slate-500 sm:col-span-5 sm:text-base">
              {t.desc}
            </p>
          </motion.div>
        ))}
        <div className="border-t border-slate-200" />
      </div>
    </section>
  );
}
